import React from "react";
import DepartmentSection from "./department/DepartmentSection";
import ShiftTimingSection from "./shiftTiming/ShiftTimingSection";
import WorkTypeSection from "./workType/WorkTypeSection";
import ShiftTypeSection from "./shiftType/ShiftTypeSection";
import AssetSection from "./asset/AssetSection";

const EmployeeConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <DepartmentSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <ShiftTimingSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <WorkTypeSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <ShiftTypeSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <AssetSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default EmployeeConfigSection;
